import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import {NavLink} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {addSelected, removeSelected, markSlideAsViewed} from "../../../shared/model/redux/slides-reducer";


export const SlidesTableRow = ({row, cls}) => {

    const dispatch = useDispatch();
    const viewedSlides = useSelector((store) => store.slides.viewedSlides);
    // Отметка выводится из общего списка выделенных: так чекбокс строки
    // остается согласованным с «выделить все» и массовыми операциями
    const checked = useSelector((store) =>
        store.slides.selected.some((slide) => slide.id === row.id));
    const isViewed = viewedSlides.includes(row.id);

    // Функция для получения текстового значеия типа ИНС по коду tissue
    const getInsType = (tissue) => {
        if (!tissue) return 'Отсутствует';
        switch (tissue) {
            case 'colon':
                return 'Толстая кишка';
            case 'lung':
                return 'Легкое';
            case 'mc':
                return 'Молочная железа';
            default:
                return 'Не определено';
        }
    };

    // Функция для получения текстового статуса по коду result
    const getResultStatus = (resultCode) => {
        switch (resultCode) {
            case 0:
                return 'Не размечено';
            case 1:
                return 'Положительное';
            case 2:
                return 'Сомнительно';
            case 3:
                return 'Отрицательно';
            default:
                return 'Не размечено'; // Fallback для неизвестных кодов
        }
    };

    // Функция для получения стиля в зависимости от результата
    const getResultStyle = (resultCode) => {
        switch (resultCode) {
            case 0:
                return {color: '#777', fontStyle: 'italic'}; // Серый для "Не размечено"
            case 1:
                return {color: '#d32f2f', fontWeight: 'bold'}; // Красный для "Положительное"
            case 2:
                return {color: '#f57c00', fontWeight: 'bold'}; // Оранжевый для "Сомнительно"
            case 3:
                return {color: '#388e3c', fontWeight: 'bold'}; // Зеленый для "Отрицательно"
            default:
                return {color: '#666', fontStyle: 'italic'}; // Серый по умолчанию
        }
    };

    // Функция для рендеринга результата
    const renderResultCell = () => {
        // Если result === null, значит слайд еще в процессе обработки
        if (row.result === null) {
            return (
                <span style={{color: '#1976d2', fontStyle: 'italic'}}>
                    Размечается...
                </span>
            );
        } else {
            // Обычное отображение результата
            return (
                <p style={getResultStyle(row.result)}>
                    {getResultStatus(row.result)}
                </p>
            );
        }
    };

    const handleChange = (item) => {
        if (!checked) {
            dispatch(addSelected(item));
        } else {
            dispatch(removeSelected(item.id))
        }
    }

    const handleOpenSlide = () => {
        // Отмечаем слайд как просмотренный при клике на "Открыть"
        dispatch(markSlideAsViewed(row.id));
    }

    return (
        <TableRow className={cls}>

            <TableCell align="center">
                <Checkbox checked={checked}
                          onChange={() => handleChange(row)}/>
            </TableCell>
            <TableCell component="th" scope="row">
                {getInsType(row.tissue)}
            </TableCell>
            <TableCell component="th" scope="row">
                {row.name}
            </TableCell>
            <TableCell align="center">
                {row.load_date ? new Date(row.load_date).toISOString().slice(0, 19).replace('T', ' ') : ''}
            </TableCell>
            <TableCell align="center"><p>{row.status === true ? 'Готово' : 'Не готово'}</p></TableCell>
            <TableCell align="center">
                {row.dzi ? (
                    <NavLink to={`/view/${row.id}/`} target='_blank' onClick={handleOpenSlide}>
                        <button className={'openButton'}>Открыть</button>
                    </NavLink>
                ) : (
                    <span style={{color: '#666', fontStyle: 'italic'}}>
                        Конвертация...
                    </span>
                )}
            </TableCell>
            <TableCell align="center">
                {row.processing_date ? new Date(row.processing_date).toISOString().slice(0, 19).replace('T', ' ') : ''}
            </TableCell>
            <TableCell align="center">
                {renderResultCell()}
            </TableCell>
            <TableCell align="center">
                {row.conclusion ? 'Да' : 'Нет'}
                </TableCell>
            <TableCell align="center">
                <p>{isViewed ? 'Да' : 'Нет'}</p>
            </TableCell>
        </TableRow>
    );
}
